module.exports = {"211322001":"叶柏寿街道","211322002":"红山街道","211322003":"铁南街道","211322004":"万寿街道","211322101":"朱碌科镇","211322102":"建平镇","211322103":"黑水镇","211322104":"喀喇沁镇","211322105":"北二十家子镇","211322106":"沙海镇","211322108":"哈拉道口镇","211322109":"榆树林子镇","211322110":"老官地镇","211322111":"深井镇","211322112":"奎德素镇","211322113":"小塘镇","211322114":"马场镇","211322115":"昌隆镇","211322117":"张家营子镇","211322118":"青峰山镇","211322119":"太平庄镇","211322205":"青松岭乡","211322206":"杨树岭乡","211322209":"罗福沟乡","211322211":"烧锅营子乡","211322214":"白山乡","211322218":"三家蒙古族乡","211322220":"义成功乡","211322400":"八家国营农场","211322401":"热水国营畜牧农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211322.json
// module id = 681
// module chunks = 0